import { chunk } from './chunk/chunk';
import { createInString } from './createInString';
import { fetchAllPages } from './fetchAllPages';

const CHUNK_SIZE = 75;

/**
 * Fetches data in chunks using an 'in' filter, handling pagination automatically
 *
 * @example
 * ```ts
 * fetchInFilter(({ value, page, size }) =>
 *   queryClient.fetchQuery(
 *     useHoofdstuk.getOptions({
 *       page,
 *       size,
 *       filter: [{
 *         field: '',
 *         op: 'in',
 *         value
 *       }]
 *     }),
 *     ['one', 'two', 'three'],
 *   )
 * );
 * ```
 */

export const fetchInFilter = async <
  TResponse extends {
    num_objects?: number;
    num_pages?: number;
    objects?: TData[];
    page?: number;
    size?: number;
  },
  TData = NonNullable<TResponse['objects']>[number],
>(
  fetchFunction: (props: {
    value: string;
    page: number;
    size: number;
  }) => Promise<TResponse>,
  values: string[]
) => {
  const chunks = chunk(values, CHUNK_SIZE);

  const responses = await Promise.all(
    chunks.map((values) => {
      return fetchAllPages((page) =>
        fetchFunction({ value: createInString(values), page, size: CHUNK_SIZE })
      );
    })
  );

  return responses.flat(2);
};
